import { render, staticRenderFns } from "./Prestazioni.vue?vue&type=template&id=31bf7722&scoped=true&"
import script from "./Prestazioni.vue?vue&type=script&lang=js&"
export * from "./Prestazioni.vue?vue&type=script&lang=js&"
import style0 from "./Prestazioni.vue?vue&type=style&index=0&id=31bf7722&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31bf7722",
  null
  
)

export default component.exports